(() => {
  'use strict';
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[đĐ]/g, 'd').replace(/[łŁ]/g, 'l').toLowerCase();
  const init = root => {
    root.querySelectorAll('[data-ct-context]').forEach(panel => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const input = panel.querySelector('[data-ct-context-search]');
      const list = panel.querySelector('[data-ct-context-links]');
      const empty = panel.querySelector('[data-ct-context-empty]');
      if (!input || !list) return;
      input.addEventListener('input', () => {
        const query = normalize(input.value).trim();
        let visible = 0;
        [...list.children].forEach(item => {
          item.hidden = !normalize(item.textContent).includes(query);
          if (!item.hidden) visible++;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });
    root.querySelectorAll('.ct-mega').forEach(menu => {
      if (menu.dataset.ctReady) return;
      menu.dataset.ctReady = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('.ct-mega[open]').forEach(other => { if (other !== menu) other.open = false; });
      });
    });
  };
  const route = location.pathname.split('/').filter(Boolean);
  const current = route[route.indexOf('collections') + 1] || '';
  document.querySelectorAll('.ct-primary-nav a').forEach(anchor => {
    if (new URL(anchor.href).pathname === location.pathname) anchor.setAttribute('aria-current', 'page');
  });
  let league = '';
  for (const name of ['nfl', 'mlb', 'nba', 'nhl', 'mls']) {
    if (current === 'ct-' + name || current.startsWith('ct-team-' + name + '-')) league = 'ct-' + name;
  }
  if (current === 'ct-national-teams' || current.startsWith('ct-national-') || current.startsWith('ct-team-nt-')) league = 'ct-national-teams';
  if (current === 'ct-european-football' || current.startsWith('ct-football-') || (current.startsWith('ct-team-') && !league)) league = 'ct-european-football';
  document.querySelectorAll('[data-ct-league]').forEach(link => {
    if (link.dataset.ctLeague === league) link.setAttribute('aria-current', 'page');
  });
  const header = document.querySelector('.shopify-section-group-header-group');
  if (header) {
    const measure = () => document.documentElement.style.setProperty('--ct-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('ct:catalog-ready', event => init(event.target));
})();
